import { callBackendApi } from "../components/service/axios";

export const getFeatureToggles = async () => {
  return await callBackendApi("get", "/bff/feature-toggles");
};
